import { PropsWithChildren } from 'react';
import { getDataIdGenerator } from '../../shared/utils/dataId';
import { Tile } from '../interfaces/tile';
import styles from './TileWrapper.module.scss';

export interface TileWrapperProps<T extends Tile = Tile> {
  tile: T;
  tileWidth: string;
  onClick?: (data: T) => void;
}

export function TileWrapper<T extends Tile = Tile>({
  tile,
  onClick,
  tileWidth,
  children
}: PropsWithChildren<TileWrapperProps<T>>) {
  const dataIdGenerator = getDataIdGenerator(String(tile.id), 'tile-wrapper');

  return (
    <button
      role='gridcell'
      type='button'
      className={styles.tile}
      style={{
        background: 'transparent',
        color: 'var(--text-default-color)',
        padding: 0,
        outline: 0,
        border: 0,
        width: tileWidth
      }}
      key={tile.id}
      onClick={() => {
        if (onClick) {
          onClick(tile);
        }
      }}
      data-id={dataIdGenerator('button')}
    >
      {children}
    </button>
  );
}
